import React from 'react';

import { CommonModalData } from '../../../types';

type Props = Pick<CommonModalData, 'setDetailsFormProps'> & {
  isFormFilled: boolean;
  isDirty: boolean;
};

function useDetailsFormProps({ setDetailsFormProps, isFormFilled, isDirty }: Props) {
  React.useEffect(() => {
    setDetailsFormProps((p) => ({ ...p, isFilled: isFormFilled }));

    return () => {
      setDetailsFormProps((p) => ({ ...p, isFilled: false }));
    };
  }, [isFormFilled]);

  React.useEffect(() => {
    setDetailsFormProps((p) => ({ ...p, hasChanges: isDirty }));

    return () => {
      setDetailsFormProps((p) => ({ ...p, hasChanges: false }));
    };
  }, [isDirty]);
}

export { useDetailsFormProps };
